module.exports = __webpack_public_path__ + "static/media/project1-cover.91e91fe8.png";